var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-container",class:{'search-center':!_vm.isHiddenSearchBox}},[_c('div',{staticClass:"search-title"},[_c('span',{staticClass:"line"}),_vm._t("title")],2),(_vm.isHiddenSearchBox)?_c('div',{staticClass:"search-wap-all"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }